import {ref} from 'vue';

export default {
    install: (app, options) => {
        const networkGeographicRegions = ref([]);
        const networkGeographicCountries = ref([]);
        const networkSalesRegions = ref([]);
        const networkSalesCountries = ref([]);

        const loadNetworkParameters = (urlParameters) => {
            const defaultUrlParameters = {};

            urlParameters = Object.assign(defaultUrlParameters, urlParameters)

            const urlSearchParams = new URLSearchParams(urlParameters);

            window.lazy_axios.get(`/dashboard/network/parameters?${urlSearchParams.toString()}`)
                .then((response) => {
                    if (response.data.geographic_regions) {
                        networkGeographicRegions.value = response.data.geographic_regions;
                    }

                    if (response.data.geographic_countries) {
                        networkGeographicCountries.value = response.data.geographic_countries;
                    }

                    if (response.data.sales_regions) {
                        networkSalesRegions.value = response.data.sales_regions;
                    }

                    if (response.data.sales_countries) {
                        networkSalesCountries.value = response.data.sales_countries;
                    }
                });
        };

        app.provide('networkGeographicRegions', networkGeographicRegions);
        app.provide('networkGeographicCountries', networkGeographicCountries);
        app.provide('networkSalesRegions', networkSalesRegions);
        app.provide('networkSalesCountries', networkSalesCountries);

        app.provide('loadNetworkParameters', loadNetworkParameters);
    },
}
